// Totaliza linhas de receita para os subtotais de grupo e o total geral do
// relatorio. Cada linha esta em no maximo uma das tres classificacoes
// (a vencer / pago / em atraso); linhas sem flag entram apenas no total.
export interface LinhaTotalizavel {
  valorNumerico: number;
  aVencerFlag?: boolean;
  pagoFlag?: boolean;
  emAtrasoFlag?: boolean;
}

export interface TotaisReceitas {
  total: number;
  aVencer: number;
  pago: number;
  emAtraso: number;
  quantidade: number;
}

export function calcularTotaisReceitas(linhas: LinhaTotalizavel[]): TotaisReceitas {
  const totais: TotaisReceitas = { total: 0, aVencer: 0, pago: 0, emAtraso: 0, quantidade: 0 };
  for (const l of linhas) {
    const valor = l.valorNumerico || 0;
    totais.total += valor;
    totais.quantidade += 1;
    if (l.aVencerFlag) totais.aVencer += valor;
    if (l.pagoFlag) totais.pago += valor;
    if (l.emAtrasoFlag) totais.emAtraso += valor;
  }
  return totais;
}
